//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {  },
  data () {
    return {
      // 数据示例
      // headerConfig: {
      //   title: {text: '[M00272304]测试'},
      //   desc: {text: '总积分 : 0', link: '123'}
      // },
    }
  },
  props: ['config'],
  computed: {},
  methods: {}
}
